import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_FAMILY_LIST_SAGA } from "../sagaTypes";
import { loaderAction, familyFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_family_list`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetFamilyList(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('subscription_id', args.data.subscription_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Добавляем пользователей и открываем форму
            yield put(familyFormAction({
                open: true,
                subscription_id: args.data.subscription_id,
                owner: response.owner,
                users: [],
                userInput: '',
                checkedUsers: response.users
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetFamilyList() {
    yield takeLatest(GET_FAMILY_LIST_SAGA, workerGetFamilyList);
}